var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.$t('search.searchProducts.header')}},[_c('SearchProducts',{attrs:{"start-date":_vm.start,"end-date":_vm.end,"type":_vm.type,"download":_vm.$t('search.searchProducts.download')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }